module.exports = __webpack_public_path__ + "static/img/f_first_06.38dbcaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_06.png
// module id = Niur
// module chunks = 9